export default "__VITE_ASSET__CoragDhW__"